export default "__VITE_ASSET__374c2569__"